<template>
    <div class="container-fluid">
    
        <!-- Page Heading -->
        <h1 class="h3 mb-2 text-gray-800">Olá {{ this.first_name }} {{ this.last_name }}</h1>
        <p class="mb-4">O email para acesso ao sistema é {{ this.email }}.</p>
        
    
       
    
      
    
        <div class="card shadow mb-4">
            <div class="card-header py-3 d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-start align-items-center gap-3">
                    <div>                
                        <h5 class="m-0 font-weight-bold text-primary">Perfil</h5>
                    </div>

                </div>
            </div>

            <div class="card-body">
                <div class="perfil"  style="margin-top: 2%;">
                    <div class="row">
                        <div class="col-md-6">
                            <ul>
                                <li class="profile-item"><strong>Email:</strong> {{ email }}</li>
                                <li class="profile-item"><strong>Nome Completo</strong> {{ first_name }} {{ last_name }}</li>

                            </ul>
                        </div>
                        <div class="col-md-6">
                            <ul>
                                <li class="profile-item"><strong>Área Lys:</strong> {{ internal_sector }}</li>
                                <li class="profile-item"><strong>Quando entrou na Lys:</strong> {{ date_joined }}</li>
                                <li class="profile-item"><strong>Data Nascimento:</strong> {{ date_joined }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        
    </div>
    </template>
    
    
      
    <script>
import Loader from "../shared/painel/Loader.vue";
import { http } from "../../http";
    export default {
        components: {
            Loader,
        },
        name: 'Profile',
        data() {
            return {
                first_name: localStorage.getItem('first_name'),
                last_name: localStorage.getItem('last_name'),
                email: localStorage.getItem('email'),
                internal_sector: null,
                date_joined: null,
                birthday: null,

            }
        },
        mounted() {
           this.getProfile()
        },
        methods: {
            getProfile() {
                var payload = {
                    token: localStorage.getItem('user_session')
                }
                http.post("get-profile/", payload)
                .then((response) => {
                    this.first_name = response.data.first_name
                    this.last_name = response.data.last_name
                    this.email = response.data.email
                    this.internal_sector = response.data.internal_sector
                    this.date_joined = this.formatDate(response.data.date_joined)
                    this.birthday = this.formatDate(response.data.birthday)
                })
                .catch((error) => {
                    console.log(error)
                })
            },
            formatDate(dateString) {
                const options = { year: 'numeric', month: '2-digit', day: '2-digit'};
                return new Date(dateString).toLocaleDateString('pt-BR', options);
            }
           
           
        }
    }
    </script>
      
      
    <style>
        .btn-pagination {
            margin: none;
            border: none;
            background-color: transparent;
            color: black;
            font-weight: bold;
        }

        .pagination {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
        }

        .profile-item {
            margin-bottom: 10px;
            border: 1px solid #706666;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            padding: 10px;
            border-radius: 5px;
        }
    </style>
    